'use client'

import { useSearchParams } from 'next/navigation'
import { createNavigation } from 'next-intl/navigation'
import { useMemo } from 'react'
import { routing } from './i18n/routing'

export const { usePathname, useRouter } = createNavigation(routing)

export const useAsPath = () => {
    const pathname = usePathname()
    const searchParams = useSearchParams()

    return useMemo(() => {
        return searchParams.size > 0 ? `${pathname}?${searchParams}` : pathname
    }, [pathname, searchParams])
}

export const useQueryParams = (): { [key: string]: string } => {
    const searchParams = useSearchParams()

    return useMemo(() => {
        return Object.fromEntries(searchParams.entries())
    }, [searchParams])
}
